var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-title"},[_c('div',{staticClass:"otnotice",attrs:{"id":_vm.divId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }